import React, { useState, useEffect } from "react";
import Profile from "../../../Assets/images/avatar.png";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { useAuth } from "../../../Contexts/AuthenticateProvider";

const ProfileStage = ({ customerDetails, onVerified }) => {
    const [photoFile, setPhotoFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const { hasPermission } = useAuth();
    // Defense in depth: KycCard already hides/locks this tile without permission,
    // but guard the submit handler and disable the inputs here too, in case the
    // component is ever reached another way.
    const canSubmit = hasPermission("customer.photo.manage");

    useEffect(() => {
        setPhotoFile(null);
        setPreview(customerDetails?.photo?.image || customerDetails?.profilePhoto || null);
    }, [customerDetails]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setPhotoFile(file);
        }
    };

    const handleSubmit = async () => {
        if (!canSubmit) {
            toast.error("You don't have permission to manage this customer's photo");
            return;
        }
        if (!photoFile) {
            toast.error("Please choose a photo to upload");
            return;
        }
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("photo", photoFile);
            const response = await Handler({
                method: "patch",
                url: `/staff/customer/${customerDetails?.customerId}/photo`,
                data: formData,
                formdata: true,
            });
            if (response?.success) {
                toast.success(response?.data?.message || "Photo uploaded successfully");
                setTimeout(() => {
                    setLoading(false);
                    onVerified?.();
                }, 1200);
            } else {
                setLoading(false);
                toast.error(response?.data?.message || "Photo upload failed");
            }
        } catch (error) {
            setLoading(false);
            toast.error("Failed to upload photo");
        }
    };

    return (
        <>
            {!canSubmit ? (
                <div className="alert alert-warning small mb-3">
                    You don't have permission to manage this customer's photo.
                </div>
            ) : null}
            <div className="col-12 text-center mb-4">
                <div className="position-relative d-inline-block">
                    <img
                        src={preview || Profile}
                        alt="Preview"
                        className="rounded-circle border"
                        width="130"
                        height="130"
                        style={{ objectFit: "cover" }}
                    />
                    <input
                        type="file"
                        accept="image/*"
                        data-crop-aspect="1"
                        disabled={loading || !canSubmit}
                        className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                        onChange={handleImageChange}
                    />
                </div>
                <div className="mt-2 small text-muted">Upload Profile Photo</div>
            </div>

            <div className="text-center mt-4">
                <button
                    className="btn btn-primary px-4"
                    onClick={handleSubmit}
                    disabled={loading || !photoFile || !canSubmit}
                >
                    {loading ? "Uploading..." : "Upload Photo"}
                </button>
            </div>
        </>
    );
};

export default ProfileStage;
